<template>
  <svg
    id="icon-chevron-right"
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 7 12"
    :fill="fill"
  >
    <path
      d="M6.287 6.089c0 .2-.07.369-.228.521l-4.57 4.471a.645.645 0 0 1-.475.193.674.674 0 0 1-.686-.68c0-.187.082-.357.205-.486l4.125-4.02L.533 2.07a.707.707 0 0 1-.205-.492c0-.38.305-.674.686-.674.187 0 .345.065.474.194l4.57 4.47a.712.712 0 0 1 .23.522Z"
    />
  </svg>
</template>

<script>
import { iconPropsFunc } from "./mixins/icons";

export default {
  name: "IconChevronRight",
  mixins: [iconPropsFunc()],
};
</script>

<style lang="scss" scoped></style>
